import { render, staticRenderFns } from "./SPUAutoUpShelfDrawer.vue?vue&type=template&id=55affdd6&scoped=true"
import script from "./SPUAutoUpShelfDrawer.vue?vue&type=script&lang=ts"
export * from "./SPUAutoUpShelfDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55affdd6",
  null
  
)

export default component.exports